import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, generatePath } from 'react-router-dom';

import BonusIcon from 'components/BonusIcon';
import { getCardDetails, getCardStatus } from './CardDetailsMapping';
import { dreamteamUtilities } from 'utilities/dreamteamUtilities';
import { ReactGACategories } from 'constants/appEnums';
import { BonusIdentifier, BonusStatus } from 'constants/appEnums';
import routes from 'constants/routes';
import './BonusCard.scss';

export enum BonusCardType {
  ReadyToUse = 'ready',
  Locked = 'locked'
}

interface IBonusCard {
  identifier: BonusIdentifier;
}

export interface IReadyBonusCard extends IBonusCard {
  type: BonusCardType.ReadyToUse;
  expirationDate: number;
  status: BonusStatus;
}

export interface ILockedBonusCard extends IBonusCard {
  type: BonusCardType.Locked;
}

export type IBonusCardProps = IReadyBonusCard | ILockedBonusCard;

const BonusCard = (props: IBonusCardProps) => {
  const { t } = useTranslation();
  const history = useHistory();
  const cardDetails = getCardDetails(t, props);
  const cardStatus = getCardStatus(t, props);

  const onClick = () => {
    dreamteamUtilities.recordEventGA(ReactGACategories.nav, `Went to bonus card ${props.identifier}`);
    history.push(
      generatePath(routes.BONUS_DETAILS.route, {
        bonusType: props.identifier
      })
    );
  };

  return (
    <div className="bonus-card" onClick={onClick} data-testid="bonus-card">
      <div className="bonus-card__body">
        <BonusIcon className="bonus-card__icon" icon={cardDetails.icon} active={cardStatus.active} />
        <div className="bonus-card__name">{cardDetails.name}</div>
        <div className="bonus-card__description">{cardDetails.description}</div>
      </div>
      <div className="bonus-card__separator" />
      <div className={`bonus-card__footer bonus-card__footer--${cardStatus.style}`} data-testid="bonus-card-footer">
        <cardStatus.statusIcon className="bonus-card__status-icon" />
        <span className="bonus-card__status-text">{cardStatus.statusText}</span>
      </div>
    </div>
  );
};

export default BonusCard;
